import axios from "axios";

import { getLocalData, _tokenName } from "../common/helpers/localData";

const baseURL = process.env.REACT_APP_COMPANY_API ?? 'http://localhost:4000'

const companyApi = axios.create({baseURL})

companyApi.interceptors.request.use((req) => {
  req.url = baseURL + req.url;

  return req;
});

// Add Authorization header
companyApi.interceptors.request.use((req) => {
  if (!req.headers.Authorization) {
    const token = getLocalData(_tokenName)

    if (token) {
      req.headers.Authorization = `Bearer ${token}`
    }
  }

  return req;
});

// Handle errors; redirect to login on Unauthorized
companyApi.interceptors.response.use(
  (res) => res,

  (res) => {
    const err = (res.response && res.response.data && res.response.data.error) || res;
    err.status = (res.response && res.response.status) || res.status;
    return Promise.reject(err);
  },
);

export default companyApi;